import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './StrangerChat1.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ChatInterface from '../FreeChat/ChatInterface';

export default function StrangerChat1() {
  const navigate = useNavigate();
  const [showChat, setShowChat] = useState(false);

  // Handler functions
  const handleFindSomeoneNew = () => {
    alert('Finding a new chat partner...');
    // Could navigate to chat matching page
  };

  const handleSearch = () => {
    alert('Opening search...');
  };

  const handleNotifications = () => {
    alert('Opening notifications...');
  };

  const handleInfo = () => {
    alert('Showing chat information...');
  };

  const handleAttachment = () => {
    alert('Opening attachment picker...');
  };

  const handleVoiceMessage = () => {
    alert('Recording voice message...');
  };

  const handleEmoji = () => {
    alert('Opening emoji picker...');
  };

  const handleSendMessage = () => {
    alert('Sending message...');
  };

  return (
    <div className="stranger-chat1-page page-with-header">
      <Header />
      
      {/* Orange Header Bar */}
      <div className="orange-header">
        <div className="orange-header-content">
          <div className="user-info">
            <div className="user-avatar">RG</div>
            <span className="user-name">Rachel Gmartz</span>
          </div>
          <div className="header-actions">
            <button className="find-someone-btn" onClick={handleFindSomeoneNew}>TÌM NGƯỜI MỚI</button>
            <button className="header-icon" onClick={handleSearch}>🔍</button>
            <button className="header-icon" onClick={handleNotifications}>🔔</button>
            <button className="header-icon" onClick={handleInfo}>ℹ️</button>
          </div>
        </div>
      </div>

      {/* Main Chat Section */}
      <section className="stranger-chat-section">
        <div className="chat-content">
          {/* Chat Messages */}
          <div className="chat-messages">
            <div className="message stranger-message">
              <div className="message-bubble stranger-bubble">
                <p>Chào... Tôi không thường nói chuyện với mọi người nhiều, nhưng tôi nghĩ hôm nay tôi cần điều này.</p>
                <span className="timestamp">04:50 PM</span>
              </div>
            </div>
            
            <div className="message user-message">
              <div className="message-bubble user-bubble">
                <p>Đôi khi việc chủ động liên lạc là phần khó nhất. Tôi vui vì không phải làm điều này một mình.</p>
                <span className="timestamp">04:50 PM</span>
              </div>
            </div>
            
            <div className="message stranger-message">
              <div className="message-bubble stranger-bubble">
                <p>Đã yên lặng từ lâu rồi. Cảm ơn vì không phán xét.</p>
                <span className="timestamp">04:51 PM</span>
              </div>
            </div>
            
            <div className="message user-message">
              <div className="message-bubble user-bubble">
                <p>Không cần lời nói ở đây. Chúng ta chỉ cần là con người, cùng nhau một chút.</p>
                <span className="timestamp">04:50 PM</span>
              </div>
            </div>
            
            <div className="message stranger-message">
              <div className="message-bubble stranger-bubble">
                <p>Love you, too</p>
                <span className="timestamp">04:52 PM</span>
              </div>
            </div>
          </div>

          {/* Chat Input */}
          <div className="chat-input">
            <div className="input-icons">
              <button className="input-icon" onClick={handleAttachment}>📎</button>
            </div>
            <div className="input-field">
              <input 
                type="text" 
                placeholder="Message Random..." 
                className="message-input"
              />
            </div>
            <div className="input-actions">
              <button className="input-icon" onClick={handleVoiceMessage}>🎤</button>
              <button className="input-icon" onClick={handleEmoji}>😊</button>
              <button className="send-btn" onClick={handleSendMessage}>
                Send
                <span className="send-icon">✈️</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

